module.exports = __webpack_public_path__ + "static/media/24a.073848b4.jpg";